import * as React from "react";
import { commonResx } from "../../resxDist/commonResx";
import { WithEditModeViewerProps } from "../../sharedHOC/withEditMode/withEditMode";
import { HyperLink } from "./HyperLink";
import * as styles from "./hyperlinkValueViewer.less";

export const HyperlinkValueViewer: React.FunctionComponent<WithEditModeViewerProps> = props => {
    const { value, wrapperClassName, disabled } = props;
    const linkWrapperClassName = `${wrapperClassName} ${styles.link_wrapper}`;
    const href = ep.common.trySetWebHTTPProtocol(value);

    return (
        <div className={linkWrapperClassName}>
            <HyperLink className={styles.hyperlink} colored={true} tabIndex={-1} href={href}>
                {value}
            </HyperLink>
            {!disabled && value && <span className={styles.change_text}> — {commonResx.change}</span>}
        </div>
    );
};
